import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToHash } from '@/lib/scroll';

/**
 * Scroll manager for route changes:
 *  - With a hash (e.g. "/#services"), smooth-scroll the target flush below the
 *    fixed header (offset measured live). Retries briefly since the target may
 *    mount a frame later.
 *  - Without a hash, scroll to the top.
 */
export function useScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      let attempts = 0;
      const scrollToTarget = () => {
        if (!scrollToHash(hash) && attempts++ < 20) {
          setTimeout(scrollToTarget, 50);
        }
      };
      requestAnimationFrame(scrollToTarget);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);
}
